import { render, staticRenderFns } from "./MRDemographics.vue?vue&type=template&id=20095767"
import script from "./MRDemographics.vue?vue&type=script&lang=js"
export * from "./MRDemographics.vue?vue&type=script&lang=js"
import style0 from "./MRDemographics.vue?vue&type=style&index=0&id=20095767&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports